import { render } from "./ForResources.vue?vue&type=template&id=a3b7d4fe&scoped=true&ts=true"
import script from "./ForResources.vue?vue&type=script&lang=ts"
export * from "./ForResources.vue?vue&type=script&lang=ts"

import "./ForResources.vue?vue&type=style&index=0&id=a3b7d4fe&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b7d4fe"]])

export default __exports__